import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Observable, filter, map } from 'rxjs';
import { AppSignalDataService } from './app-signal-data.service';
import dayjs from 'dayjs';
import { VersionService } from '@core/services/version.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {

  isLoggedIn$!: Observable<boolean>;

  isCollapsed: boolean = false;
  size: NzButtonSize = 'large';

  isHome: boolean = false;
  year: number = dayjs().year();

  textVb: boolean = true;
  tituloMenu: string = 'Sidac';
  tituloPagina: string = 'Titulo Pagina';
  subTituloPagina: string = 'SubTitulo Pagina';
  version: string = '';
  buildDate: string = '';

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private permissionService: NgxPermissionsService,
    private activedRouted: ActivatedRoute,
    private roleService: NgxRolesService,
    public appSignalDataService: AppSignalDataService,
    private cdr: ChangeDetectorRef,
    private versionService: VersionService
  ) {
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isHome = event.url == '/';
      }
    })

    if (this.authenticationService.currentUserValue != null) {
      if (this.authenticationService.currentUserValue.roles)
        this.permissionService.loadPermissions(this.authenticationService.currentUserValue.roles);
      if (this.authenticationService.currentUserValue.perfil && this.authenticationService.currentUserValue.roles)
        this.roleService.addRole(this.authenticationService.currentUserValue.perfil.perfil, this.authenticationService.currentUserValue.roles);
    }
     this.versionService.getVersion().subscribe(data => {
      this.version = data.version;
      this.buildDate = data.buildDate;
    });
  }


  private rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  updateIsCollapsed() {
    this.isCollapsed = !this.isCollapsed;
    this.appSignalDataService.updateCollapsedMenuAside(this.isCollapsed);
  }
}
